import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors, typography, shadows, spacing, borderRadius } from './theme';

export const venueReportStyles = StyleSheet.create({
  container: {
    flex: 1,
    padding: spacing.xxl,
    backgroundColor: colors.backgroundPrimary,
    maxWidth: 1200,
    width: '100%',
    alignSelf: 'center',
    marginTop: 40,
  
  },
  title: {
    fontFamily: typography.primaryFont,
    fontSize: getResponsiveValue({
      mobile: 24,
      tablet: 28,
      laptop: 32,
      desktop: 42,
    }),
    color: colors.textPrimary,
    marginBottom: spacing.md,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: typography.primaryFont,
    fontSize: getResponsiveValue({
      mobile: 12,
      tablet: 14,
      laptop: 16,
      desktop: 18,
    }),
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: spacing.xl,
    textAlign: 'center',
  },
  section: {
    marginBottom: spacing.xl,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: spacing.lg,
    borderRadius: borderRadius.md,
  },
  sectionTitle: {
    fontFamily: typography.primaryFont,
    fontSize: getResponsiveValue({
      mobile: 20,
      tablet: 22,
      laptop: 24,
      desktop: 26,
    }),
    color: '#000000',
    marginBottom: spacing.md,
  },
  formGroup: {
    marginBottom: spacing.md,
  },
  label: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: '#000000',
    marginBottom: spacing.sm,
  },
  sublabel: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: spacing.sm,
    fontStyle: 'italic',
  },
  userTypeContainer: {
    marginBottom: spacing.xl,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    padding: spacing.lg,
    borderRadius: borderRadius.md,
  },
  input: {
    backgroundColor: '#434252',
    borderRadius: borderRadius.sm,
    padding: spacing.md,
    color: 'white',
    fontFamily: typography.primaryFont,
    fontSize: 16,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
      transition: 'all 0.2s ease',
      ':hover': {
        borderColor: 'rgba(255, 255, 255, 0.3)',
      },
      ':focus': {
        borderColor: 'rgba(255, 255, 255, 0.4)',
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.1)',
      },
    }),
  },
  dropdown: {
    backgroundColor: '#434252',
    color: 'white',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: borderRadius.sm,
    padding: spacing.md,
    fontFamily: typography.primaryFont,
    fontSize: 16,
    width: '100%',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
      cursor: 'pointer',
    }),
  },
  gradeDropdown: {
    width: '100%',
    backgroundColor: '#434252',
    color: 'white',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: borderRadius.sm,
    padding: spacing.md,
    fontFamily: typography.primaryFont,
    fontSize: 16,
  },
  textArea: {
    backgroundColor: '#434252',
    borderRadius: borderRadius.sm,
    padding: spacing.md,
    color: 'white',
    fontFamily: typography.primaryFont,
    fontSize: 16,
    minHeight: 120,
    textAlignVertical: 'top',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
      transition: 'all 0.2s ease',
      ':hover': {
        borderColor: 'rgba(255, 255, 255, 0.3)',
      },
      ':focus': {
        borderColor: 'rgba(255, 255, 255, 0.4)',
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.1)',
      },
    }),
  },
  errorText: {
    color: colors.error,
    fontFamily: typography.primaryFont,
    fontSize: 14,
    marginTop: spacing.xs,
  },
  mediaSection: {
    marginBottom: spacing.xl,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: spacing.lg,
    borderRadius: borderRadius.md,
  },
  mediaText: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textSecondary,
    marginBottom: spacing.md,
  },
  mediaButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    marginBottom: spacing.md,
  },
  mediaButton: {
    backgroundColor: '#434252',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: borderRadius.sm,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 120,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        borderColor: 'rgba(255, 255, 255, 0.3)',
        transform: 'translateY(-1px)',
      },
    }),
  },
  mediaButtonText: {
    color: 'white',
    fontFamily: typography.primaryFont,
    fontSize: 14,
  },
  mediaPreviewContainer: {
    marginTop: spacing.md,
  },
  mediaPreviewText: {
    color: '#000000',
    fontSize: 14,
    marginBottom: spacing.xs,
  },
  mediaCount: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: '#000000',
    marginBottom: spacing.xs,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: spacing.md,
    marginTop: spacing.xl,
  },
  submitButton: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.sm,
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButtonText: {
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 16,
    fontWeight: '700',
  },
  cancelButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.sm,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelButtonText: {
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 16,
  },
  profileInput: {
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderRadius: 15,
    padding: getResponsiveValue({
      mobile: 8,
      tablet: 10,
      laptop: 12,
      desktop: 12,
    }),
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 16,
      desktop: 16,
    }),
    width: '100%',
    ...(Platform.OS === 'web' && {
      outlineWidth: 0,
      border: 'none',
    }),
  },
  radioGroup: {
    flexDirection: 'column',
    gap: spacing.sm,
  },
  
  radioButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    padding: spacing.sm,
    borderRadius: borderRadius.sm,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
      }
    }),
  },
  
  radioButtonSelected: {
    backgroundColor: 'rgba(11, 181, 223, 0.2)',
    borderColor: 'rgba(11, 181, 223, 0.5)',
  },
  
  radioButtonText: {
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 14,
  },
  
  radioButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },

  // New styles for view specs layout matching
  viewSpecsContainer: {
    flex: 1,
    minWidth: getResponsiveValue({
      mobile: '90vw',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%'
    }),
    alignSelf: getResponsiveValue({
      mobile: 'center',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
    borderWidth: 3,
    borderColor: '#000000',
    borderRadius: 10,
    padding: 15,
    height: 'auto',
    minHeight: 'fit-content',
    flexGrow: 1,
    flexShrink: 0,
    marginTop: 0,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    marginBottom: spacing.xl,
  },

  specRow: {
    width: '100%',
    alignItems: 'center',
    flexShrink: 0,
  },

  specRowContent: {
    width: '80%',
    paddingVertical: 15,
    alignItems: 'flex-start',
    flexShrink: 0,
  },

  specLabel: {
    fontSize: getResponsiveValue({
      mobile: 18,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    fontWeight: 'bold',
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    width: '100%',
    textAlign: 'center',
    marginBottom: 8,
    flexWrap: 'wrap',
  },

  searchBarInput: {
    fontFamily: 'VastagoGrotesk',
    backgroundColor: 'transparent',
    color: '#000000',
    width: '100%',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 18,
      desktop: 18
    }),
    minHeight: getResponsiveValue({
      mobile: 40,
      tablet: 50,
      laptop: 50,
      desktop: 50,
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 15,
      tablet: 20,
      laptop: 20,
      desktop: 20,
    }),
    paddingVertical: getResponsiveValue({
      mobile: 10,
      tablet: 12,
      laptop: 12,
      desktop: 12,
    }),
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.5)',
    textAlign: 'center',
    flexWrap: 'wrap',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
      borderBottomWidth: 1,
      borderBottomColor: 'rgba(0, 0, 0, 0.5)',
    }),
  },

  notesInput: {
    height: getResponsiveValue({
      mobile: 120,
      tablet: 140,
      laptop: 140,
      desktop: 160,
    }),
    textAlignVertical: 'top',
    textAlign: 'left',
    paddingTop: getResponsiveValue({
      mobile: 15,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
  },

  specDivider: {
    width: '60%',
    height: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    marginVertical: 5,
    alignSelf: 'center',
  },
}); 